import { render } from "./MatchRow.vue?vue&type=template&id=7437b2a2"
import script from "./MatchRow.vue?vue&type=script&lang=js"
export * from "./MatchRow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__